export const PaymentSectionId = {
  PaymentPlans: 'payment-plans',
  PaymentOption: 'payment-option',
} as const;